import { api } from '../api';
import env from '../env';
import { logError } from '../logging';

type OpenStudentHubWithSsoOptions = {
  /** Same-app path on Student Hub (must start with `/`) */
  returnTo?: string;
  /** Open target for window.open; default `_blank` */
  target?: string;
};

export async function openStudentHubWithSso({
  returnTo,
  target = '_blank',
}: OpenStudentHubWithSsoOptions = {}): Promise<boolean> {
  try {
    const { code } = await api.sso.createTicket.fetchMutation(undefined);
    const url = new URL('/sso/callback', env.REACT_APP_STUDENT_HUB);
    url.searchParams.set('code', code);
    if (returnTo && returnTo.startsWith('/') && !returnTo.startsWith('//')) {
      url.searchParams.set('returnTo', returnTo);
    }
    window.open(url.toString(), target);
    return true;
  } catch (e) {
    const message = e instanceof Error ? e.message : String(e);
    logError(message, null, { message: `Failed to open Student Hub via SSO: ${message}` });
    window.alert('Unable to open Student Hub right now. Please try again.');
    return false;
  }
}
